import IMask from "imask";

(function ($) {
    $(document).ready(function () {
        const isEditAddress = window.location.href.includes('edit-address');
        if (!isEditAddress) {
            return;
        }
        init();
    });

    function init() {
        const personTypeField = $('[id="vindi-pagamentos/billing_persontype"]');

        if (!personTypeField.length) {
            return;
        }

        function applyMask(input, fieldType) {
            if (!input || !input.length) return;

            const element = input[0];

            if (fieldType === 'cpf') {
                IMask(element, {
                    mask: '000.000.000-00'
                });
            } else if (fieldType === 'cnpj') {
                IMask(element, {
                    mask: '**.***.***/****-00'
                });
            }
        }

        function createFieldIfNeeded(fieldType) {
            const fieldId = `vindi-pagamentos/billing_${fieldType}`;
            const wrapperId = `${fieldId}_field`;

            const existingField = $(`[id="${wrapperId}"]`);
            if (existingField.length > 0) {
                const input = existingField.find('input');
                applyMask(input, fieldType);
                return existingField;
            }


            const label = fieldType === 'cpf' ? 'CPF' : 'CNPJ';
            const pattern = fieldType === 'cpf' ? '000.000.000-00' : '**.***.***/****-00';

            const fieldHtml = `
                <p class="form-row form-row-wide validate-required" id="${wrapperId}">
                    <label for="${fieldId}" class="">
                        ${label}&nbsp;<abbr class="required" title="obrigatório">*</abbr>
                    </label>
                    <span class="woocommerce-input-wrapper">
                        <input type="text" 
                               class="input-text" 
                               name="_wc_billing/${fieldId}" 
                               id="${fieldId}" 
                               placeholder="${pattern}" 
                               value="" 
                               required="required">
                    </span>
                </p>
            `;

            const personTypeWrapper = personTypeField.closest('.form-row');
            const newField = $(fieldHtml);
            personTypeWrapper.after(newField);

            const input = newField.find('input');
            applyMask(input, fieldType);

            return newField;
        }

        function toggleFields() {
            const personType = personTypeField.val();

            if (personType === '1') {
                const cpfField = createFieldIfNeeded('cpf');
                cpfField.show().find('input').prop('required', true);

                const cnpjWrapper = $('[id*="billing_cnpj_field"]').filter(function () {
                    return this.id.includes('vindi');
                });
                if (cnpjWrapper.length > 0) {
                    cnpjWrapper.hide().find('input').prop('required', false).val('');
                }


            } else if (personType === '2') {
                const cnpjField = createFieldIfNeeded('cnpj');
                cnpjField.show().find('input').prop('required', true);

                const cpfWrapper = $('[id*="billing_cpf_field"]').filter(function () {
                    return this.id.includes('vindi');
                });
                if (cpfWrapper.length > 0) {
                    cpfWrapper.hide().find('input').prop('required', false).val('');
                }

            }
        }

        toggleFields();

        personTypeField.on('change', toggleFields);

    }
})(jQuery);